(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
  var nativeBtn = document.querySelector('[data-native-share]');
  var socialLinks = document.querySelectorAll('.share-buttons__link');
  var label = document.querySelector('.share-buttons__label');

  if (nativeBtn && navigator.share) {
    nativeBtn.style.display = '';
    socialLinks.forEach(function(el) { el.style.display = 'none'; });
    if (label) label.style.display = 'none';

    nativeBtn.addEventListener('click', function() {
      navigator.share({
        title: this.dataset.shareTitle,
        url: this.dataset.shareUrl
      }).catch(function() {});
    });
  }

  document.querySelectorAll('[data-copy-url]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = this.getAttribute('data-copy-url');
      var labelCopy = this.getAttribute('data-label-copy');
      var labelCopied = this.getAttribute('data-label-copied');
      navigator.clipboard.writeText(url).then(function() {
        btn.setAttribute('aria-label', labelCopied);
        setTimeout(function() { btn.setAttribute('aria-label', labelCopy); }, 2000);
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
